export const APP_VERSION = '6.3.0';
